import { useEffect, useMemo, useState } from 'react';
import { api } from '../../lib/api.js';
import { buildPreviewModel } from '../../lib/briefModel.js';
import { useAuth } from '../../context/AuthContext.jsx';
import HomeHero from '../../components/home/HomeHero.jsx';
import HomeFeaturedArticle from '../../components/home/HomeFeaturedArticle.jsx';
import HomeStudiosPodcast from '../../components/home/HomeStudiosPodcast.jsx';
import HomeCategories from '../../components/home/HomeCategories.jsx';
import HomeLatestPosts from '../../components/home/HomeLatestPosts.jsx';

export default function Home() {
  const { loading: authLoading } = useAuth();
  const [briefState, setBriefState] = useState({
    status: 'loading',
    edition: null,
    error: null,
  });

  useEffect(() => {
    if (authLoading) return;

    let cancelled = false;
    setBriefState((s) => (s.status === 'ready' ? s : { status: 'loading', edition: null, error: null }));

    (async () => {
      try {
        const data = await api.get('/editions/today?preview=1');
        if (!cancelled) {
          setBriefState({
            status: 'ready',
            edition: data?.edition || null,
            error: null,
          });
        }
      } catch (err) {
        if (!cancelled) {
          setBriefState({
            status: 'error',
            edition: null,
            error: err.message,
          });
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [authLoading]);

  const model = useMemo(() => {
    if (briefState.status !== 'ready' || !briefState.edition) return null;
    return buildPreviewModel(briefState.edition, '/today');
  }, [briefState.status, briefState.edition]);

  return (
    <div className="bg-[#faf9f6] min-h-full">
      <HomeHero />
      <HomeFeaturedArticle
        model={model}
        status={briefState.status}
        error={briefState.error}
      />
      <HomeStudiosPodcast />
      <HomeCategories />
      <HomeLatestPosts />
    </div>
  );
}
